import React, { useEffect } from 'react';
import { MapPin, Phone, Car, Navigation } from 'lucide-react';

const Location = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-fixed"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/banner.jpg)` }}
        >
          <div className="absolute inset-0 bg-slate-900/70"></div>
        </div>
        <div className="relative z-10 text-center px-4 animate-slide-up">
          <span className="text-secondary font-bold tracking-widest uppercase mb-4 block">Contact & Location</span>
          <h1 className="text-5xl md:text-6xl font-display font-bold text-white mb-6">오시는 길</h1>
          <p className="text-xl text-slate-200 max-w-2xl mx-auto font-light">
            파워테크로 오시는 방법을 안내해 드립니다.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-24">
        <div className="section-container">
          <div className="grid lg:grid-cols-3 gap-12">

            {/* Contact Info Cards */}
            <div className="lg:col-span-1 space-y-8">
              <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center">
                  <MapPin className="text-primary mr-3" /> 회사 정보
                </h3>
                <address className="not-italic space-y-4 text-slate-600">
                  <div className="flex items-start">
                    <span className="font-semibold text-slate-800 w-20 flex-shrink-0">주소</span>
                    <span className="leading-relaxed">충청남도 천안시 서북구<br />백석공단1로 70, 본관 2층</span>
                  </div>
                </address>
              </div>

              <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
                <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center">
                  <Phone className="text-secondary mr-3" /> 연락처
                </h3>
                <div className="space-y-4 text-slate-600">
                  <div className="flex items-center">
                    <span className="font-semibold text-slate-800 w-20">전화</span>
                    <a href="tel:041-576-7573" className="hover:text-primary transition-colors">041-576-7573</a>
                  </div>
                  <div className="flex items-center">
                    <span className="font-semibold text-slate-800 w-20">팩스</span>
                    <span>041-576-7574</span>
                  </div>
                  <div className="flex items-center">
                    <span className="font-semibold text-slate-800 w-20">이메일</span>
                    <a href="mailto:ygm1028@powerteck.co.kr" className="hover:text-primary transition-colors">ygm1028@powerteck.co.kr</a>
                  </div>
                </div>
              </div>

              <div className="bg-primary text-white p-8 rounded-2xl shadow-xl">
                <h3 className="text-xl font-bold mb-6 flex items-center">
                  <Car className="text-accent mr-3" /> 방문 안내
                </h3>
                <p className="opacity-90 leading-relaxed mb-4">
                  건물 1층에 방문객을 위한 무료 주차 공간이 마련되어 있습니다.
                </p>
              </div>
            </div>

            {/* Map Section */}
            <div className="lg:col-span-2 h-full min-h-[500px] bg-slate-100 rounded-2xl overflow-hidden shadow-lg border border-slate-200 relative group">
              <iframe
                title="파워테크 위치"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3196.848805727181!2d127.1068229385152!3d36.82897619449061!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b279e84c40d0d%3A0xd1951e9751023a6d!2z7YyM7JuM7YWM7YGsKOyjvCk!5e0!3m2!1sko!2skr!4v1727863550601!5m2!1sko!2skr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="grayscale group-hover:grayscale-0 transition-all duration-500"
              ></iframe>
              <div className="absolute bottom-4 right-4 flex space-x-2">
                <a
                  href="https://map.kakao.com/link/to/파워테크,36.828976,127.106822"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-yellow-400 text-slate-900 px-4 py-2 rounded-lg font-bold text-sm shadow-lg hover:bg-yellow-300 transition-colors flex items-center"
                >
                  <Navigation size={16} className="mr-2" /> 카카오맵
                </a>
                <a
                  href="https://map.naver.com/v5/search/파워테크/place/36.828976,127.106822"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#03C75A] text-white px-4 py-2 rounded-lg font-bold text-sm shadow-lg hover:bg-[#02b350] transition-colors flex items-center"
                >
                  <Navigation size={16} className="mr-2" /> 네이버지도
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Location;
